import Vue from "vue";
import CountryFlag from "vue-country-flag";

Vue.component("country-flag", CountryFlag);
